import React, { Fragment} from 'react';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';

const Success = (props) => {

    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <h1>Checkout</h1>
                                </div>
                            </div>
                        </div>
                </section>
                <section className="privacy_policy_section section_space pt-0">
                    <div className="container">   
                        <div className="row">
                            <div className="col-lg-6 m-auto">
                                <div className="checkout_form_div text-center">
                                    <h2 style={{color:'#9769FF'}}>Payment Successful!</h2>
                                    <p>Your payment was processed successfully. Check your email inbox & spam folder for login credentials. 
                                        If you need any help or have questions about your order, just let us know.
                                    </p>
                                    <a href="/" className="btn btn-primary mt-3 p-3">Go to Home</a>
 
                                </div>
                            </div>
                                    
                        </div>
                    </div>
                </section>
               
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default Success;